import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../backend/supabase';

const PendingApproval = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');

  useEffect(() => {
    const checkApprovalStatus = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          navigate('/signup/login');
          return;
        }

        const { data: profile, error: profileError } = await supabase
          .from('users')
          .select('first_name, is_approved')
          .eq('id', user.id)
          .single();

        if (profileError) throw profileError;

        if (profile?.first_name) {
          setUserName(profile.first_name);
        }

        if (profile?.is_approved) {
          navigate('/dashboard');
        }
      } catch (error) {
        console.error('Error checking approval status:', error);
      }
    };

    checkApprovalStatus();
    const interval = setInterval(checkApprovalStatus, 30000);
    return () => clearInterval(interval);
  }, [navigate]);

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate('/signup/login');
  };

  return (
    <div className="min-h-screen bg-[#fef6ef] flex flex-col">
      {/* Header */}
      <div className="flex justify-between items-center p-6">
        <div className="text-center text-xl font-bold tracking-wider text-[#34261E]">Lawdie</div>
        <button 
          onClick={handleSignOut}
          className="text-[#34261E] hover:text-[#5D341A] text-sm transition-colors duration-300"
        >
          Sign Out
        </button>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="max-w-2xl w-full p-8">
          <div className="text-center">
            {userName && (
              <p className="text-xl text-[#34261E] mb-4">
                Hi, {userName}
              </p>
            )}
            <h1 className="text-3xl font-semibold text-[#34261E] mb-6">
              Your Bar ID is being verified
            </h1>
            <p className="text-[#5D341A] mb-8">
              Thank you for signing up with Lawdie. We are reviewing your profile and will
              notify you once the review is complete. In the meantime, here's what you can expect
              once you're approved.
            </p>

            {/* Features Stack */}
            <div className="space-y-4">
              {/* Referral Network */}
              <div className="bg-white rounded-lg p-6 shadow-sm border border-[#d8d1c7] hover:border-[#34261E] transition-colors duration-300">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-[#34261E] rounded-lg flex items-center justify-center">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                  <div className="flex-1 text-left">
                    <h3 className="font-semibold text-lg text-[#34261E] mb-2">Referral Network</h3>
                    <p className="text-[#5D341A]">
                      Connect with verified attorneys and expand your referral network
                    </p>
                  </div>
                </div>
              </div>

              {/* AI Paralegal */}
              <div className="bg-white rounded-lg p-6 shadow-sm border border-[#d8d1c7] hover:border-[#34261E] transition-colors duration-300">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-[#34261E] rounded-lg flex items-center justify-center">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div className="flex-1 text-left">
                    <h3 className="font-semibold text-lg text-[#34261E] mb-2">AI Paralegal</h3>
                    <p className="text-[#5D341A]">
                      Access AI-powered legal research and document analysis tools
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingApproval;